module.exports = __webpack_public_path__ + "img/10-Judge-01.dffe34dc.png";